import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    breakdownPayroll: {},
    omittedEmployeeIds: [],
    emailForChangePassword: "",
    allAdmins: [],
    showCompanySetting: "",
    showInactiveEmployee: "",
    signupData: {},
    walletBalance: "",
    payrollDate: "",
    payrollMonth: "",
    payrollYear: "",
    payrollTitle: "",
    amountDebited: "",
    compensationTotal: "",
    transactionCost: "",
    quickpay: {},
    onetime: {},
    query: {},
    managedClient: null,
    liveDemoEmail: "",
    liveDemoPassword: "",
    jobseekerPassport: "",
    jobseekerDocumentLength: "",
    employeesTotal: "",
    pendingQueries: ""
  },
  modules: {
    auth
  }
});
